import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const electoralValidationSchema = yup.object().shape({
  newReleaseReason: yup.string().required('Campo obbligatorio'),
  newCardNumber: yup
    .string()
    .matches(regexOnlyNumber, 'Campo numerico')
    .required('Campo obbligatorio'),
});
